import type { Breakpoint } from '@commons/types/styles';

import MediaQuery from './MediaQuery';
import { ResponsiveProvider, useMediaQueries } from './provider';

/**
 * Type definition for an object with the active status of each breakpoint.
 */

export type ActiveBreakpoints = Record<Breakpoint, boolean>;

/**
 * Garda mobile-first breakpoints.
 */

export const breakpoints: Record<Breakpoint, number> = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1440,
};

export { ResponsiveProvider, useMediaQueries, MediaQuery };
